import type { HandshakeMessageFull } from "@/types";
import { adminDetailTabSearch } from "@/components/bookings/bookingAdminDetailTabs";

type HandshakeBookingDestination = {
  booking_id: string;
  seller_user_id: string;
};

/** Admin canonical detail for a booking (seller-scoped when possible). */
export function adminBookingDetailPath(
  bookingId: string,
  sellerUserId?: string | null,
): string {
  if (sellerUserId) {
    return `/sellers/${sellerUserId}/bookings/${bookingId}`;
  }
  return `/bookings/${bookingId}`;
}

/** Booking detail path for a handshake session, opened on its Chat tab. */
export function adminHandshakeDestinationPath(
  session: HandshakeBookingDestination,
): string {
  return `${adminBookingDetailPath(session.booking_id, session.seller_user_id)}${adminDetailTabSearch("chat")}`;
}

export function countHandshakeMessages(messages: HandshakeMessageFull[]) {
  const total = messages.length;
  const blocked = messages.filter(
    (message) => message.message_status === "BLOCKED",
  ).length;
  return { total, blocked, delivered: total - blocked };
}
